import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { RDReadyNav } from './RDReadyNav';
import { RDReadyFooter } from './RDReadyFooter';
export function RDReadyLayout() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return <div className="flex min-h-screen flex-col bg-white font-sans text-[#1E293B]" data-id="element-3754">
      <RDReadyNav data-id="element-3755" />
      <main className="flex-1" data-id="element-3756">
        <Outlet data-id="element-3757" />
      </main>
      <RDReadyFooter data-id="element-3758" />
    </div>;
}